"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function checkAllQuestionsAreOptional(content) {
    const allQuestionsAreOptional = content.children.find((childContent) => childContent.contributeToCompleteStatus === true)
        ? false
        : true;
    return allQuestionsAreOptional;
}
exports.checkAllQuestionsAreOptional = checkAllQuestionsAreOptional;
//# sourceMappingURL=checkAllQuestionsAreOptional.js.map